import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-opportunity-action-group',
    template: ` <div class="cmps-coaching-opportunity-action-group--info">
            <cmps-icon svgIcon="__internal:information"></cmps-icon>
            <span>{{ coached ? coachedLabel : uncoachedLabel }}</span>
        </div>
        <div class="cmps-coaching-opportunity-action-group--actions">
            <button
                cmpsButton
                (click)="observationAction.emit($event)"
                *ngIf="hasObservationAction"
            >
                <cmps-icon svgIcon="__internal:loupe"></cmps-icon>
                <span cmpsButtonLabel>{{ observationActionLabel }}</span>
            </button>
            <button
                cmpsButton
                (click)="commitmentAction.emit($event)"
                *ngIf="hasObservationAction"
            >
                <cmps-icon svgIcon="__internal:folder-account"></cmps-icon>
                <span cmpsButtonLabel>{{ commitmentActionLabel }}</span>
            </button>
        </div>`,
    host: {
        class: 'cmps-coaching-opportunity-action-group',
        '[class.cmps-coaching-opportunity-action-group--coached]': 'coached',
        '[class.cmps-coaching-opportunity-action-group--uncoached]': '!coached',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsOpportunityActionGroupComponent {
    @Input() coached: boolean;
    @Input() coachedLabel: string;
    @Input() uncoachedLabel: string;
    @Input() hasObservationAction: boolean;
    @Input() observationActionLabel: string;
    @Output() observationAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Input() hasCommitmentAction: boolean;
    @Input() commitmentActionLabel: string;
    @Output() commitmentAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.observationAction = new EventEmitter();
        this.commitmentAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.observationAction.complete();
        this.commitmentAction.complete();
    }
}
